import { Injectable } from '@angular/core';
import { Airport } from '../../models/airport';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';

interface AirportAPIResponse {
  status: number;
  result: Airport[];
}

@Injectable({
  providedIn: 'root'
})

export class AirportListService {
  airportList = new Subject<Airport[]>();
  selectedAirport = new Subject<string>();

  constructor(private http: HttpClient) {
    if (localStorage.getItem('selectedAirportCode')) {
      this.selectedAirport.next(localStorage.getItem('selectedAirportCode'));
    }
  }

  airportApi = 'https://api2.travelx.ai/api/getAirportList?&key=azxsdfghbvjki&pid=dmf&servicetype=dutyfree';

  public setSelectedAirport(value: string) {
    localStorage.setItem('selectedAirportCode', value);
    this.selectedAirport.next(value);
  }

  public getSelectedAirport(): string {
    return localStorage.getItem('selectedAirportCode');
  }

  getAllAirports(searchTerm = '') {
    // tslint:disable-next-line: prefer-const
    let partQuery = searchTerm && searchTerm !== '' ? '&airport=' + searchTerm.trim() : '';
    this.http.get<AirportAPIResponse>(this.airportApi + partQuery).subscribe(
      resData => {
        this.airportList.next(resData.result);
      },
      error => {
        this.airportList.next([]);
      }
    );
  }


/*   getSelectedAirport() {

    return  'undefined' !== typeof this.selectedAirport ? this.selectedAirport : false;
  }
 */}

